export default __webpack_public_path__ + "static/media/camion.e15574e9.png";